<template>
<div class="sc">
  <el-menu :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo"  text-color="#5D5D5D" active-text-color="#409EFF">
    <template v-for="menu in user.staffRole">
        <el-submenu :index="menu.menuName" v-if="menu.menus.length > 0">
            <template slot="title">
              <i class="iconfont" :class="menu.icon"></i>
              <span>{{menu.menuName}}</span>
            </template>
            <el-menu-item-group background-color="#1f2d3d">
              <el-menu-item v-for="chmenu in menu.menus" :index="chmenu.url" :key="chmenu.menuId">
                <i :class="chmenu.icon"></i>
                <span>{{chmenu.menuName}}</span>
              </el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-if="menu.menus.length == 0" :index="menu.url">
            <i class="iconfont" :class="menu.icon"></i>
            <span>{{menu.menuName}}</span>
        </el-menu-item>
    </template>
  </el-menu>
</div>
</template>
<script>
//import { menu } from '../api/userMG'
export default {
  props: ['user'],
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  created() {
    let res = {
      success: true,
      // data: [
      //   {
      //     menuid: 5,  //√
      //     icon: 'iconfont icon-kehu', //√
      //     menuname: '客户管理', //√
      //     hasThird: null,
      //     url: null,  //√
      //     menus: [
      //       {
      //         menuid: 51,
      //         icon: 'iconfont icon-qiweiguanli',
      //         menuname: '企微客户',
      //         hasThird: 'N',
      //         url: 'customer/Eamc',
      //         menus: null
      //       }
      //     ]
      //   },
      //   {
      //     menuid: 6,
      //     icon: 'iconfont icon-layui-myicon-guanli',
      //     menuname: '系统管理',
      //     hasThird: null,
      //     url: null,
      //     menus: [
      //       {
      //         menuid: 62,
      //         icon: 'iconfont icon-yuangongguanli3',
      //         menuname: '员工管理',
      //         hasThird: 'N',
      //         url: 'system/Staff1',
      //         menus: null
      //       },
      //     ]
      //   },
      //   {
      //     menuid: 7,
      //     icon: 'iconfont icon-liaotian1',
      //     menuname: '聊天监管',
      //     hasThird: null,
      //     url: null,
      //     menus: [
      //       {
      //         menuid: 71,
      //         icon: 'iconfont icon-liaotian',
      //         menuname: '聊天审计-员工列表',
      //         hasThird: 'N',
      //         url: 'chat/StaffChatSupervise',
      //         menus: null
      //       },
      //       {
      //         menuid: 72,
      //         icon: 'iconfont icon-liaotian',
      //         menuname: '聊天审计-客户列表',
      //         hasThird: 'N',
      //         url: 'chat/CusChatSupervise',
      //         menus: null
      //       }
      //     ]
      //   },
      // ],
      msg: 'success'
    }
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  },
}
</script>
<style lang="scss" scoped>
  .sc {
  }
  /deep/.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 210px;
    min-height: 400px;
  }
  /deep/.el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }
  /deep/.el-menu-item-group__title {
    padding: 0px !important;
  }
  /deep/.el-menu-bg {
    background-color: #1f2d3d !important;
  }
  /deep/.el-menu {
    border: none;
  }
  /deep/ .el-menu-item{
    background-color: white !important;
    .iconfont {
      margin-right: 13px;
    }
  }
  
  /deep/ .el-menu-item:hover{
    background: #E6F7FF !important;
    color: rgb(64, 158, 255) !important;
    .iconfont{
      color: rgb(64, 158, 255) !important;
    }
  }
// }


/* .el-submenu__title:hover {
	  background: #333 !important;
	  color: #fff!important;
	} */
  .el-submenu__title{
    .iconfont{
      margin-right: 13px;
    }
  }
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>